module.exports = __webpack_public_path__ + "img/logo-inline-dark.51dac04c.svg";